// import dayjs from 'dayjs';
import { request } from '@umijs/max';
import { message } from 'antd';

export function saveToken(token: string) {
  localStorage.setItem('token', token);
}

export async function getPage<T>(
  url: string,
  params: any,
  options?: { [key: string]: any },
) {
  params['pageNo'] = params.current;
  delete params.current;
  const res: any = await request<T>(url, {
    method: 'GET',
    params,
    ...(options || {}),
  });

  return {
    data: res?.records || [],
    total: res?.total,
    success: true,
  };
}

export function handleResult(result: boolean, isAdd: boolean = true) {
  if (result === true) {
    message.success(`${isAdd ? '新增' : '更新'}成功`);
  } else {
    message.warning(`${isAdd ? '新增' : '更新'}错误`);
  }
}

export function handleDeleteResult(result: boolean) {
  if (result === true) {
    message.success(`删除成功`);
  } else {
    message.warning(`删除错误`);
  }
}
export const getBaseUrl = () => {
  return process.env.NODE_ENV === 'production' ? '' : '';
};

export const delayTime = (time: number) => {
  return new Promise((ok) => {
    setTimeout(() => {
      ok(true);
    }, time);
  });
};
